import { Size, Spacing } from '@opallabs/gem'
import { Icon } from '@opallabs/lapidary'
import type { WithRequiredTheme } from '@opallabs/lapidary'
import * as styles from './styles'
import { NotificationType } from './types'

type Lookup = {
  [key in NotificationType]: string
}

export const emptyStateText: Lookup = {
  download: 'Downloads like content exports become available here',
  notification: 'You don’t have any notifications right now',
}

export const emptyStateIcon: Lookup = {
  download: 'gem-download',
  notification: 'gem-bell',
}

type EmptyStateProps = Readonly<
  WithRequiredTheme & {
    type: NotificationType
  }
>
export const EmptyState: React.FC<EmptyStateProps> = ({ theme, type }) => (
  <div css={styles.emptyState({ theme })}>
    <Icon
      ariaMode="hidden"
      glyph={emptyStateIcon[type]}
      height={Size.Icon * 3.125}
      styleOverrides={{
        container: {
          marginBlockEnd: Spacing.M * 1.25,
        },
      }}
      width={Size.Icon * 3.125}
    />
    <p>{emptyStateText[type]}</p>
  </div>
)
EmptyState.displayName =
  'Darwin: EmptyState ← NotificationsPanel ← PersonalPanel'
